//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTrueFalse, formatTime } from '../../components/helpers.js'
import Table from '../../components/Table/Table.vue'
import DateTimeField from '../../components/Field/DateTimeField.vue'

export default {
  components: {
    Table,
    DateTimeField
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      formatTrueFalse: formatTrueFalse,
      columns: [
        {
          name: 'commandTime',
          label: 'Время',
          align: 'left',
          field: 'commandTime',
          format: formatTime,
          sortable: true
        },
        {
          name: 'commandName',
          label: 'Операция',
          align: 'left',
          field: 'commandName',
          sortable: true
        },
        {
          name: 'resultDescription',
          label: 'Результат',
          align: 'left',
          field: 'resultDescription',
          sortable: true
        }
      ]
    }
  }
}

